import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { PrivilegedGroupsRolesList } from '../partials/PrivilegedGroupsRolesList';
import { GroupToRole } from './PrivilegedGroupsEditView';

type PrivilegedGroupsDefaultProps = {
  groupToRolesList: GroupToRole[];
};

export function PrivilegedGroupsDefault({ groupToRolesList }: PrivilegedGroupsDefaultProps) {
  return <PrivilegedGroupsRolesList groupToRolesList={groupToRolesList} />;
}

export const PrivilegedGroupsDefaultView = asFetchableView(PrivilegedGroupsDefault);
export type PrivilegedGroupsDefaultView = ComponentProps<typeof PrivilegedGroupsDefaultView>;
